/* unplugin-vue-components disabled */import { render } from "./xNavLayout.vue?vue&type=template&id=bdf0d58e&scoped=true"
const script = {}

import "./xNavLayout.vue?vue&type=style&index=0&id=bdf0d58e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdf0d58e"]])

export default __exports__